import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

class RadioGroup extends React.Component {
    constructor (props) {
        super(props);
        if(!this.props.disabledLocalState) {
            this.state = {
                selected: this.props.selected
            };
        }
        this.handleChange = this.handleChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(newProps){
        if ('selected' in newProps) {
            this.setState({
                selected: newProps.selected
            });
        }
    }

    handleChange (value, e) {
        if(this.props.disabledLocalState) {
            if (this.props.selected !== e.target.value && this.props.onChange) {
                this.props.onChange(value, e);
            }
        } else {
            const { selected } = this.state;
            if (selected !== e.target.value) {
                if (this.props.onChange) {
                    this.props.onChange(value, e);
                }
                this.setState({
                    selected: e.target.value
                });
            }
        }
    }

    renderRadioButtons () {
        let retChildren = React.Children.map(this.props.children, child => (
            React.cloneElement(child, {
                checked: this.props.disabledLocalState ? child.props.value === this.props.selected : child.props.value === this.state.selected,
                disabled: this.props.disabled || child.props.disabled,
                reverse: this.props.reverse || child.props.reverse,
                name: this.props.name,
                onChange: this.handleChange
            })));
        return retChildren;
    }

    render () {
        const { onChange, reverse, disabled, name, className, disabledLocalState, ...otherProps } = this.props;
        return (
            <div className={cx('i-flex', className)} {...otherProps}>
                {this.renderRadioButtons()}
            </div>
        );
    }
}

RadioGroup.propTypes = {
    /**
     * Children of the radio component
     * @ignore
     */
    children: PropTypes.node,
    /**
     * Custom classes to be passed to component
     * @ignore
     */
    className: PropTypes.string,
    /**
     * Disables the disabledLocalState
     */
    disabledLocalState: PropTypes.bool,
    /**
     * Disables the radiogroup
     */
    disabled: PropTypes.bool,
    /**
     * Reverse with render the text to the left of the radio
     */
    reverse: PropTypes.bool,
    /**
     * Handler for the onChange event
     */
    onChange: PropTypes.func,
    /**
     * Name of the component
     */
    name: PropTypes.string.isRequired,
    /**
     * Default selection value, corresponds to the `value` attribute on the Radio
     */
    selected: PropTypes.string
};

RadioGroup.defaultProps = {
    children: null,
    className: '',
    disabledLocalState: false,
    disabled: false,
    reverse: false,
    onChange: null,
    selected: ''
};

export default RadioGroup;